/**
 * Person entity model — ES module version of MyScripts/Entities/Person.ts
 */

import type { PersonData, HeightData, WeightData, PhoneNumberData, EmailData, AttachmentData, AttachmentInfoData, ConnectionsData, WarningData } from '@/services/api-types';

export type { PersonData };

export const PERSON_DATE_FIELDS = ['dob', 'driversLicenseIssued', 'driversLicenseExpires'] as const;

export function isPersonDateField(name: string): boolean {
  return (PERSON_DATE_FIELDS as readonly string[]).includes(name);
}

export function createPerson(data?: Partial<PersonData>): PersonData {
  return {
    id: null,
    firstName: null,
    lastName: null,
    middleName: null,
    suffix: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    zip: null,
    aliases: null,
    employeeId: null,
    employer: null,
    dob: null,
    gender: null,
    race: null,
    height: { displayUnits: 'ft', mm: 0 },
    weight: { displayUnits: 'lbs', grams: 0 },
    createdByCompanyId: null,
    createdByCompanyName: null,
    eyeColor: null,
    hairColor: null,
    notes: null,
    locName: null,
    locAddress: null,
    locAddress2: null,
    locCity: null,
    locState: null,
    locZip: null,
    locCountry: null,
    locFormattedAddress: null,
    latitude: null,
    longitude: null,
    customLocationId: null,
    driversLicenseNum: null,
    driversLicenseType: null,
    driversLicenseClass: null,
    driversLicenseIssued: null,
    driversLicenseExpires: null,
    driversLicenseState: null,
    driversLicenseRestrictions: null,
    phoneNumbers: [],
    emails: [],
    descriptionPicId: null,
    attachmentList: [],
    connections: { people: [], vehicles: [], clients: [], businesses: [], reports: [] },
    warnings: [],
    citationCount: null,
    ...data,
  };
}
